<template>
    <v-snackbar
        :color="color"
        :timeout="timer"
        v-model="showSnackbar"
        top
        multi-line
        @click.native="showSnackbar = false"
        class="tw-cursor-pointer"
    >
        <v-icon left>{{icon}}</v-icon>{{message}}
    </v-snackbar>
</template>

<script>
export default {
    name: "SnackbarComponent",
    props: {
        'default': {
            // Not sure if anyone will ever pass in new defaults to use, but at least there's the option, right?
            type: Object,
            required: false,
            default: function () {
                return {
                    color: 'success',
                    timer: 4500,
                    icon: 'mdi-check',
                }
            }
        },
    },
    data() {
        return{
            showSnackbar: false,
            message: '',
            color: this.default.color,
            icon: this.default.icon,
            timer: this.default.timer,
        }
    },
    methods:{
        // This is a generic method to show the snackbar without using presets like success/error/warning
        show(data) {
            if (!message.length) return
            this.setOptions({
                message: data.message,
                color: data.color || this.default.color,
                timer: data.timer || this.default.timer,
                icon: data.icon || this.default.icon,
            })
        },
        /*
        These routines can be triggered using syntax like $vm0.$root.snackbar.success("It worked!")
        */

        // This method will show a green snackbar that contains a success icon
        success(message) {
            if (!message.length) return
            this.setOptions({
                message: message,
                color: 'success',
                icon: 'mdi-check',
            })
        },

        // This method will show a red snackbar that contains an error icon
        error(message) {
            if (!message.length) return
            this.setOptions({
                message: message,
                color: 'error',
                icon: 'mdi-alert-circle',
            })
        },

        // This method will show an orange snackbar that contains a warning icon
        warning(message) {
            if (!message.length) return
            this.setOptions({
                message: message,
                color: 'warning',
                icon: 'mdi-alert-circle-outline',
            })
        },
        setOptions(objNewOptions) {
            // Make sure we're only dealing with specific options
            let options = _.pick(objNewOptions, ['message', 'color', 'icon', 'timer'])

            // Loop through each one of the passed-in options
            for (const [key, value] of Object.entries(options)) {
                // Set the newly proposed value into `this`
                this.$set(this, key, value)
            }

            // If a message was specified, then that means it's time to display the snackbar.  Yum!
            if (options.message.length) {
                this.showSnackbar = true
            }
        },
    }
}
</script>
